import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { environment } from '../../../environments/environment';
import { WINDOW } from './window.token';

export const iframeOnlyGuard: CanActivateFn = () => {
  const windowRef = inject(WINDOW);
  const router = inject(Router);

  return environment.name === 'local' || windowRef.parent !== windowRef
    ? true
    : router.parseUrl('/access-denied');
};
